import { onBeforeUnmount, onMounted, onUpdated, ref } from "vue"

export default {
    name: "CardMediumPI",
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        dropdownLabel: {
            type: String,
            default: ''
        },
        piPartners: {
            type: Array,
            default: []
        },
        color: {
            type: String,
            default: ''
        }
    },
    setup(props) {  
        const selectRef = ref(null)
        const classNameColor = `nyk-card-medium${props.color}`

        function getTextWidth(text, font) {
            // Create a canvas element
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            // Set the font
            context.font = font;
            // Measure the text
            const metrics = context.measureText(text);
            return metrics.width;
        }

        const reDrawSelectSize = () => {
            const optionText = selectRef.value.options[selectRef.value.selectedIndex].text
            const fontFamily = getComputedStyle(selectRef.value).fontFamily
            const fontSize = parseFloat(getComputedStyle(selectRef.value).fontSize)
            const font = `${fontSize}px ${fontFamily}`
            selectRef.value.style.width = `${getTextWidth(optionText, font) + 28}px`
        }

        onMounted(() => {
            reDrawSelectSize()
        })
        
        const onChange = () => {
            reDrawSelectSize()
            const value = selectRef.value.value
            if (value) {
                window.location.href = value
            }
        }

        return {
            selectRef,
            classNameColor,
            onChange
        }
    }
}